
import { defineComponent, ref } from "vue";

export default /*#__PURE__*/ defineComponent({
  name: "AppHeader",
  props: {
    companyLogo: String,
    countryLabel: String,
    countryLogo: String,
    countryNormalTopHeading: String,
    countryBoldTopHeading: String,
    countryCloseLabel: String,
    countries: {
      type: String,
      default: "",
    },
    countryCloseIcon: String,
    loginLabel: String,
    loginLogo: String,
    searchLabel: String,
    searchLogo: String,
    searchNormalTopHeading: String,
    searchBoldTopHeading: String,
    searchCloseLabel: String,
    searchCloseIcon: String,
    searchPlaceholder: String,
    searchButtonLabel: String,
    searchButtonIcon: String,
    searchButtonLink: String,
  },
  setup(props) {
    const selectedIndex = ref(-1);
    const countriesJson = JSON.parse(props.countries);
    const toggleNav = (clickedIndex: number, event: MouseEvent) => {
      const primaryNav: HTMLElement | null =
        document.getElementById("primary-navigation");
      const headerNav: HTMLCollection | null = document.getElementsByClassName(
        "header__navigation-item"
      );

      if (selectedIndex.value === clickedIndex) {
        selectedIndex.value = -1;
      } else {
        selectedIndex.value = clickedIndex;
      }

      if (clickedIndex === 3) {
        primaryNav?.classList.toggle("open");
      } else {
        primaryNav?.classList.remove("open");
      }
    };

    //To close dropdown on escape press
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        selectedIndex.value = -1;
      }
    });

    return { toggleNav, selectedIndex, countriesJson };
  },
});
